let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Yxip")).then(() => parcelRequire('l0L7W'));